import { render, staticRenderFns } from "./VerticalDistribTabs.vue?vue&type=template&id=980ded04&scoped=true&"
import script from "./VerticalDistribTabs.vue?vue&type=script&lang=js&"
export * from "./VerticalDistribTabs.vue?vue&type=script&lang=js&"
import style0 from "./VerticalDistribTabs.vue?vue&type=style&index=0&id=980ded04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980ded04",
  null
  
)

export default component.exports